import React, { useEffect, useState } from "react";
import { api, fileUrl } from "../lib/api";

// <img> with bearer token via query param.
export function AuthImg({ fileId, className, alt = "" }) {
  if (!fileId) return null;
  return <img src={fileUrl(fileId)} alt={alt} className={className} />;
}

// Upload button that calls /api/uploads and returns file record via onUploaded(file)
export function UploadButton({ onUploaded, label = "Încarcă fișier", accept = "image/*", testId = "upload-btn" }) {
  const [loading, setLoading] = useState(false);
  const handle = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onUploaded?.(data);
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };
  return (
    <label data-testid={testId} className="inline-flex items-center gap-2 px-3 py-2 border border-zinc-200 rounded-md text-sm font-medium cursor-pointer hover:bg-zinc-50 transition-colors">
      <input type="file" accept={accept} onChange={handle} hidden />
      {loading ? "Se încarcă..." : label}
    </label>
  );
}
